module.exports = __webpack_public_path__ + "img/ico-ar.98f16d15.svg";